const textFieldFormEquipModel = {
  name: 'Equipment Type',
  description: 'Equipment description',
  labelDepreciation: 'Annual Depreciation',
  labelPercentualDepreciation: 'value between 0 and 100',
};

export default textFieldFormEquipModel;
